/* eslint-disable */
import { useTranslation } from "react-i18next";
import ECharts from 'echarts-for-react';
import { Chip } from '@mui/material';

import MainCard from 'components/MainCard';

function CSVReaderGraphTab({options, remainLife}) {
  const { t } = useTranslation();

  return (
    <>
    {options !== null && remainLife !== 0 && 
    <MainCard style={{marginTop:"10px"}} content={false}>
        <Chip label={`(${t('message.common.chip.remain.lifespan')}:${remainLife}${t('message.common.text.month')})`} color="primary" />
        <ECharts
          option={options}
          opts={{ renderer: 'svg', height: '250px' }}
          />
    </MainCard>
    }
    </>
  )
}
 
export default CSVReaderGraphTab;